import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { dispatch } from 'store'
import { aiLibSelectors } from 'store/features/aiLibVideo/selectors'
import { aiLibThunks } from 'store/features/aiLibVideo/thunks'
import { FETCH_LIMIT } from 'containers/SubSidebar/AiLibContent/consts'
import { getIsScrollAtBottom } from 'containers/SubSidebar/AiImageContent/HistoryTab/utils'
import { useEventListener } from 'hooks'
import debounce from 'lodash.debounce'

const SCROLL_DEBOUNCE_DELAY = 300

export const useFetchAiLibHistoryOnScroll = (
  containerRef: HTMLElement | null
) => {
  const isLoadingMore = useSelector(aiLibSelectors.isLoadingMore)
  const isInitialLoading = useSelector(aiLibSelectors.isInitialLoading)
  const historyList = useSelector(aiLibSelectors.historyList)
  const totalCount = useSelector(aiLibSelectors.historyTotalCount)

  const fetchMoreData = useCallback(() => {
    if (!containerRef || isLoadingMore || isInitialLoading) return

    const hasMoreItems = historyList.length < totalCount
    if (!hasMoreItems) return

    const isAtBottom = getIsScrollAtBottom(containerRef)
    if (isAtBottom) {
      dispatch(
        aiLibThunks.getHistory({
          offset: historyList.length,
          limit: FETCH_LIMIT
        })
      )
    }
  }, [
    containerRef,
    isLoadingMore,
    isInitialLoading,
    historyList.length,
    totalCount
  ])

  const debouncedFetchMoreData = useMemo(
    () => debounce(fetchMoreData, SCROLL_DEBOUNCE_DELAY),
    [fetchMoreData]
  )

  useEventListener('scroll', debouncedFetchMoreData, containerRef)
}
